<template>
  <div>
    <b-navbar toggleable="lg" type="light" class="custom-navbar">
      <b-navbar-toggle
        target="nav-collapse"
        class="toggle"
        label="Menu"
      ></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="w-100">
          <b-nav-item-dropdown
            v-for="(m, i) in mergedMenuItems"
            :key="i"
            :text="m.title"
            class="flex-grow-1 text-left"
            :class="{ 'menu-active': activeMenuIndex === i }"
            @click="clickedMenuIndex = i"
            style="border-right: 1px solid #777; padding-right: 1rem"
          >
            <b-dropdown-item
              v-for="(s, j) in m.subs"
              :key="j"
              @click="handleNavigation(s.route)"
              :aria-current="
                s.route === $route.path || s.route === $route.fullPath
                  ? 'page'
                  : null
              "
            >
              <span style="display: flex; align-items: center; color: #777">
                {{ s.title }}
                <img
                  v-if="
                    premiumTools.includes(s.title) ||
                    premiumDownloads.includes(s.title)
                  "
                  src="@/assets/diamond.svg"
                  height="20px"
                  alt="Premium"
                  class="ml-2"
                />
              </span>
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getDefaultJBrowse2Url } from "@/services/JBrowseService";

export default {
  data() {
    return {
      clickedMenuIndex: null,
      premiumTools: [
        "JBrowse2",
        "PhyloGenes",
        "SeqViewer",
        "BLAST",
        "Patmatch",
        "Motif Analysis",
        "Chromosome Map Tool",
        "Synteny Viewer",
        "Functional Categorization",
      ],
      premiumDownloads: ["Subscriber Data Releases"],
    };
  },
  computed: {
    ...mapGetters("downloadItems", ["getDownloadItems"]),
    ...mapGetters("newsURLs", ["getHowToPostAJobURL", "getICARAbstractsURL"]),
    activeMenuIndex() {
      const currentPath = this.$route.path;
      for (let i = 0; i < this.mergedMenuItems.length; i++) {
        if (this.mergedMenuItems[i].subs.some((s) => s.route === currentPath)) {
          return i;
        }
      }
      return this.clickedMenuIndex;
    },
    menuItemsBeforeDownload() {
      return [
        {
          title: "Advanced Search",
          subs: [
            {
              title: "Overview",
              route: "/search/overview",
            },
            {
              title: "DNA/Clones",
              route: "/search/dna",
            },
            {
              title: "Ecotypes",
              route: "/search/ecotype",
            },
            {
              title: "Genes",
              route: "/search/genes",
            },
            {
              title: "Germplasms",
              route: "/search/germplasm",
            },
            {
              title: "Keywords",
              route: "/search/keyword",
            },
            {
              title: "Markers",
              route: "/search/markers",
            },
            {
              title: "Person",
              route: "/search/community",
            },
            {
              title: "Polymorphisms/Alleles",
              route: "/search/polyallele",
            },
            {
              title: "Protein",
              route: "/search/protein",
            },
            {
              title: "Protocol",
              route: "/search/protocol",
            },
            // {
            //   title: "Germplasm",
            //   route: "/search/germplasm",
            // },
            {
              title: "Publications",
              route: "/search/publication",
            },
            {
              title: "Transposons",
              route: "/search/transposon",
            },
          ],
        },
        {
          title: "Browse",
          subs: [
            {
              title: "Overview",
              route: "/browse/overview",
            },
            {
              title: "ABRC Catalog",
              route: "https://abrc.osu.edu/catalog",
            },
            {
              title: "Gene Class Symbols",
              route: "/browse/gene_symbols",
            },
            {
              title: "Recently Added Literature",
              route: "/browse/recent_literature",
            },
            {
              title: "Transposon Families",
              route: "/browse/transposon_families",
            },
            {
              title: "Microarray Experiments",
              route: "/browse/microarray_experiments",
            },
            {
              title: "Gene Families",
              route: "/browse/gene_family",
            },
            {
              title: "2010 Projects",
              route:
                "https://www.nsf.gov/awardsearch/search-results/?PIId=&PIFirstName=&PILastName=&PIOrganization=&PIState=&PIZip=&PICountry=&ProgOrganization=&ProgEleCode=&BooleanElement=All&ProgRefCode=&BooleanRef=All&Program=the+2010+project&ProgOfficer=&Keyword=&AwardNumberOperator=&AwardAmount=&AwardInstrument=&ExpiredAwards=true&OriginalAwardDateOperator=&StartDateOperator=&ExpDateOperator=",
            },
            {
              title: "The Arabidopsis Book (TAB)",
              route: "https://bioone.org/journals/the-arabidopsis-book/issues",
            },
          ],
        },
        {
          title: "Tools",
          subs: [
            {
              title: "Overview",
              route: "/tools/overview",
            },
            {
              title: "GO Term Enrichment",
              route: "/tools/go_term_enrichment",
            },
            {
              title: "JBrowse2",
              route: getDefaultJBrowse2Url(),
            },
            {
              title: "PhyloGenes",
              route: `${process.env.VUE_APP_PHYLOGENES}`,
            },
            {
              title: "Synteny Viewer",
              route: "/tools/synteny_viewer",
            },
            {
              title: "SeqViewer",
              route: `${process.env.VUE_APP_SEQVIEWER}`,
            },
            {
              title: "Functional Categorization",
              route: `${process.env.VUE_APP_OLD_TAIR_URL}/tools/bulk/go/index.jsp`,
            },
            {
              title: "AraCyc Metabolic Pathways",
              route: "https://pmn.plantcyc.org/organism-summary?object=ARA",
            },
            {
              title: "Integrated Genome Browser",
              route: "https://bioviz.org/",
            },
            {
              title: "BLAST",
              route: `/tools/blast/`,
            },
            {
              title: "Patmatch",
              // route: `${process.env.VUE_APP_OLD_TAIR_URL}/cgi-bin/patmatch/nph-patmatch.pl`,
              route: `/tools/Patmatch`,
            },
            {
              title: "Motif Analysis",
              route: `/tools/motiffinder`,
            },
            {
              title: "Chromosome Map Tool",
              route: "/tools/chromosome_map",
            },
            {
              title: "Textpresso Full Text",
              route: "http://arabidopsis.textpresso.org/tpc",
            },
          ],
        },
        {
          title: "Portals",
          subs: [
            {
              title: "Overview",
              route: "/portals/overview",
            },
            {
              title: "Community Resources",
              route:
                "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42210773/Resources",
            },
            {
              title: "Clones/DNA Resources",
              route:
                "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42211357/Stock+Centers+DNA+Seeds+other+Physical+Resources",
            },
            {
              title: "Education and Outreach",
              route:
                "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42212939/Education+and+Outreach+Resources",
            },
            {
              title: "Gene Expression Resources",
              route:
                "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42211196/Gene+Expression+Transcriptomics+Resources",
            },
            {
              title: "Genome Annotation",
              route:
                "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42215969/Genome+Annotation",
            },
            {
              title: "MASC/Functional Genomics",
              route: "https://arabidopsisresearch.org/",
            },
            {
              title: "Metabolomics Resources",
              route:
                "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42212535/Metabolomics+Resources",
            },
            {
              title: "Mutant and Mapping Resources",
              route:
                "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42213391/Mutant+and+Mapping+Resources",
            },
            {
              title: "Nomenclature",
              route:
                "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42215953/Nomenclature",
            },
            {
              title: "Proteome Resources",
              route:
                "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42211143/Proteomics+Resources",
            },
          ],
        },
      ];
    },
    wrappedDownloadItems() {
      return {
        title: "Download",
        subs: [
          { title: "Overview", route: "/download/overview" },
          ...this.getDownloadItems,
        ],
      };
    },
    menuItemsAfterDownload() {
      return [
        {
          title: "Submit",
          subs: [
            {
              title: "Overview",
              route: "/submit/overview",
            },
            {
              title: "ABRC Stock Donation",
              route: "https://abrc.osu.edu/",
            },
            {
              title: "External Links",
              route:
                "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42216080/Data+Submission#External-Links",
            },
            // {
            //   title: "Gene Family Data",
            //   route:
            //     "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42216080/Data+Submission#Gene-Class-Symbol-Registration",
            // },
            {
              title: "Online Submission for Authors and Others",
              route: "https://goat.phoenixbioinformatics.org/",
            },
            {
              title: "Gene Structure Additions/Modifications",
              route:
                "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42216080/Data+Submission#Gene-Structure-Additions/Modifications",
            },
            {
              title: "Marker and Polymorphism Data",
              route:
                "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42216080/Data+Submission#Marker-and-Polymorphism-Data",
            },
            {
              title: "Gene Class Symbol Registration",
              route: "/submit/gene_class_symbol_registration",
            },
            {
              title: "Phenotypes",
              route:
                "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42216080/Data+Submission#Phenotypes",
            },
            {
              title: "Protocols",
              route:
                "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42216080/Data+Submission#Protocols",
            },
          ],
        },
        {
          title: "News",
          subs: [
            {
              title: "Overview",
              route: "/news/overview",
            },
            {
              title: "TAIR News",
              route: "/news/breaking-news",
            },
            // {
            //   title: "TAIR Newsletter Archive",
            //   route: "",
            // },
            {
              title: "Conferences and Events",
              route: "/news/events",
            },
            {
              title: "ICAR Abstracts",
              route: this.getICARAbstractsURL,
            },
            {
              title: "Job Postings",
              route: "/news/jobs",
            },
            {
              title: "How to Post a Job",
              route: this.getHowToPostAJobURL,
            },
          ],
        },
        {
          title: "Stocks",
          subs: [
            {
              title: "Overview",
              route:
                "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42211357/Stock+Centers+DNA+Seeds+other+Physical+Resources",
            },
            {
              title: "ABRC",
              route: "https://abrc.osu.edu/",
            },
            {
              title: "NASC",
              route: "https://arabidopsis.info/",
            },
            {
              title: "RIKEN",
              route: "https://epd.brc.riken.jp/en/",
            },
          ],
        },
      ];
    },
    mergedMenuItems() {
      // Combining local data and Vuex data

      const items = [
        ...this.menuItemsBeforeDownload,
        this.wrappedDownloadItems,
        ...this.menuItemsAfterDownload,
      ];
      return items;
    },
  },
  methods: {
    handleNavigation(route) {
      // Check if the route is an external URL
      if (this.isExternal(route)) {
        // Open the external URL
        window.open(route, "_blank");
      } else {
        // Use Vue Router for internal routes
        this.$router.push(route);
      }
    },

    isExternal(url) {
      const externalRegex = /^(https?|ftp|mailto)?:\/\//;
      return externalRegex.test(url);
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/variables.scss";

.toggle {
  color: $navbar-text-color;
}

.custom-navbar {
  background-color: $navbar-bg !important;

  // Use :deep to target child component's classes and override Bootstrap defaults
  :deep(.navbar-nav .nav-link) {
    color: $navbar-text-color !important;
    font-weight: bold;
    text-decoration: none;
  }

  // Handle hover/focus states for the nav links
  :deep(.navbar-nav .nav-link:hover),
  :deep(.navbar-nav .nav-link:focus),
  .b-nav-item-dropdown.show :deep(.nav-link) {
    color: $navbar-text-hover-color !important;
    text-decoration: none;
  }

  .b-nav-item-dropdown:hover,
  .b-nav-item-dropdown.show {
    background-color: #f0f0f0; // Keep a subtle hover for the item container
  }

  .dropdown-menu {
    background-color: $dropdown-bg;
    .dropdown-item {
      color: $dropdown-item-color;
      &:hover,
      &:focus {
        color: $dropdown-item-hover-color;
        background-color: $dropdown-item-hover-bg;
      }
    }
  }
}

.custom-navbar .nav-item-dropdown {
  text-align: left;
  flex-grow: 1;
}

@media (max-width: 767px) {
  .custom-navbar .navbar-nav {
    flex-direction: column;
    width: 100%;
  }
  .custom-navbar .nav-item-dropdown {
    width: 100%;
    text-align: center;
  }
}
.custom-dropdown-item {
  color: black;
}
</style>
